import { render, staticRenderFns } from "./ShopSortControl.vue?vue&type=template&id=054ecf70&scoped=true&"
import script from "./ShopSortControl.vue?vue&type=script&lang=js&"
export * from "./ShopSortControl.vue?vue&type=script&lang=js&"
import style0 from "./ShopSortControl.vue?vue&type=style&index=0&id=054ecf70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ecf70",
  null
  
)

export default component.exports